// extracted by mini-css-extract-plugin
export default {"root":"DesignSettingsPage_root__9PyUX","btn":"DesignSettingsPage_btn__4T3wU"};